/**
 * @fileoverview
 * This script handles rendering and managing upcoming shipments for Shopify products
 * using the Recharge SDK. It supports both subscription and one-time purchase products.
 *
 * @description
 * Main features:
 * 1. Force login via Shopify App Proxy and get the current customer session.
 * 2. Fetch customer data including subscriptions, addresses, and payment methods.
 * 3. Identify the next upcoming subscription shipment.
 * 4. Render subscription dates in the UI (both in the drawer and pop-up messages).
 * 5. Bind product variants (subscription or one-time) with upcoming shipments.
 * 6. Handle subscription creation or one-time purchase creation via Recharge.
 * 7. Update UI elements like button states, loaders, success/error messages.
 * 8. Manage modal content and messages based on the selected product type.
 * 9. Adjust the position of drawer close text dynamically on window load and resize.
 *
 * @functions
 * - updateCloseTextPosition(): Adjusts close-text position based on drawer height.
 * - triggerMessageModal(msgModal): Displays and hides modal messages for success/error.
 * - handleNextShipmentActions(button, action): Handles UI updates for shipment actions.
 * - handleModalContant(): Manages subscription/one-time product messages and quantity.
 *
 * @eventListeners
 * - Click on "#next-order-shipment-button" to update subscription frequency in drawer.
 * - Click on "#add-to-next-shipment" to handle creating subscription or one-time product.
 * - Click on close-box inside pop-up to hide messages.
 * - Window load and resize events for drawer UI adjustments.
 *
 * @dependencies
 * - Recharge SDK (recharge.auth, recharge.customer, recharge.subscription, recharge.onetime)
 * - Shopify storefront with specific HTML structure (product-form, drawer panels, radio cards)
 *
 * @notes
 * - The code assumes specific HTML selectors; adjustments may be required for theme variations.
 * - Handles both subscription and one-time products separately.
 */
// 1. Force a login right after init
recharge.auth.loginShopifyAppProxy().then(session => {
  // You can store/use session here
  const customerID = session.customerId;

  if(customerID == null || customerID == '') {
      document.getElementById('next-order-shipment').style.display = 'none'; // hide it
  }

  // 2. Complete customer data
  recharge.customer.getCustomer(session, {
      include: ["subscriptions", "addresses", "payment_methods"]
  }).then(customer => {
    // 3. Render the upcoming shipping date
    const subscriptionsListing = customer.include.subscriptions;
    const subscriptionListCount = customer.subscriptions_active_count;
    if (subscriptionListCount >= 1) {
        const element = document.getElementById('next-order-shipment-box-button');
        if (element) {
            element.style.display = 'block';
            // element.remove(); // modern way
        }
    }

    //START 1.EVENT - Add Events GA GTM [view_cta] : find the CTA ship with next order on load window
    let hasActiveSubscriptionCount;
    function findShipWithNextOrderButton(e) {
      let ctaButton = document.getElementById("next-order-shipment-button");
      let eventCurrentProductID = document.querySelector('#pdp-content .product-form [name="product-main-id"]').value;
      let eventCurrentProductTitle = document.querySelector('#pdp-content .product-form [name="product-title"]').value;
      let eventProductCurrentVariantID = document.querySelector('#pdp-content .product-form [name="items[0]id"]').value;
      let eventProductPrice = document.querySelector('.price .price-item').innerHTML;
      let ctaID = '';
      let buttonText = '';

      if(ctaButton){
        let buttonParent = document.getElementById('next-order-shipment-box-button');
        let buttonID = buttonParent.querySelectorAll('[id]');
        let spans = buttonParent.querySelectorAll('span');
        // button ID
        buttonID.forEach(el => {
          ctaID = el.id
        });
        // button text through spans
        spans.forEach(el => {
          const style = window.getComputedStyle(el);
          if (style.display === 'block') {
            buttonText = el.textContent;
          }
        });
        // 1.EVENT - Add Events GA GTM [view_cta] : find the CTA ship with next order on load window Subscription box button hit for undo button
        if (window.Shopify?.analytics) {
          window.Shopify.analytics.publish('view_cta_ship_with_next_order', {
            user_properties: {
              subscriber: true
            },
            cta_id: ctaID,
            cta_name: buttonText,
            cta_slot: "product_details_page",
            ecommerce: {
              items: [
                {
                  item_id: eventCurrentProductID,
                  item_name: eventCurrentProductTitle,
                  item_variant_id: eventProductCurrentVariantID,
                  item_price: eventProductPrice
                }
              ]
            }
          });
        }
      }
    }
    findShipWithNextOrderButton();
    // END 1.EVENT - Add Events GA GTM [view_cta]


    // Iterate the dates according to the key [next_charge_scheduled_at] and get the next upcoming shipment
    let nextShipmentDate = null, nextSubscriptionDetails = null;
    if (Array.isArray(subscriptionsListing)) {
      subscriptionsListing.forEach((subscription) => {
        if (subscription.next_charge_scheduled_at) {
          const shipmentDate = new Date(subscription.next_charge_scheduled_at);
          if (!nextShipmentDate || shipmentDate < nextShipmentDate) {
            nextShipmentDate = shipmentDate;
            nextSubscriptionDetails = subscription;
          }
        }
      });
    } else {
    console.error("subscriptionsListing is not an array:", subscriptionsListing);
    }

    /**
     * render data from page
     * 1. Date formatting accordingly
     * 2. Upcoming subscription date formatting
     */
    const date = new Date(nextShipmentDate);
    const options = { month: "short", day: "numeric", year: "numeric" };
    const upcomingSubscriptionDate = date.toLocaleDateString("en-US", options);
    const targetSubscriptions = document.querySelectorAll('#next-order-shipment .ship__next-order .date');

    targetSubscriptions.forEach(el => {
        el.innerHTML = upcomingSubscriptionDate;
    });

    const targetSuccessMessageDate = document.querySelectorAll('.pop-up-message-ship-with-next-order');
    targetSuccessMessageDate.forEach(el => {
        el.innerHTML = el.innerHTML.replace('[subscription_date]', upcomingSubscriptionDate);
    });

    const targetDetailDate = document.querySelectorAll('#next-order-shipment .detail');
    targetDetailDate.forEach(el => {
      el.innerHTML = el.innerHTML.replace(/\[subscription_date\]/g, upcomingSubscriptionDate);
    });

    // Get the value of data-selling-plan-name
    document.getElementById('next-order-shipment-button').addEventListener('click', function(e) {
      //START 2.EVENT - Add Events GA GTM [select_cta] : if user select or hit the CTA button
      hasActiveSubscriptionCount = customer.subscriptions_active_count > 0;
      console.log("hasActiveSubscriptionCount", hasActiveSubscriptionCount)

      if(hasActiveSubscriptionCount){
        let eventCurrentProductID = document.querySelector('#pdp-content .product-form [name="product-main-id"]').value;
        let eventCurrentProductTitle = document.querySelector('#pdp-content .product-form [name="product-title"]').value;
        let eventProductCurrentVariantID = document.querySelector('#pdp-content .product-form [name="items[0]id"]').value;
        let eventProductPrice = document.querySelector('.price .price-item').innerHTML;
        let ctaID = '';
        let buttonText = '';
        let buttonParent = document.getElementById('next-order-shipment-box-button');
        let buttonID = buttonParent.querySelectorAll('[id]');
        let spans = buttonParent.querySelectorAll('span');
        // button ID
        buttonID.forEach(el => {
          ctaID = el.id
        });
        // button text through spans
        spans.forEach(el => {
          const style = window.getComputedStyle(el);
          if (style.display === 'block') {
            buttonText = el.textContent;
          }
        })

        if (window.Shopify?.analytics) {
          window.Shopify.analytics.publish('select_cta_ship_with_next_order', {
            // user_properties: {
            //   subscriber: 'true'
            // },
            cta_id: ctaID,
            cta_name: buttonText,
            cta_slot: "product_details_page",
            ecommerce: {
              items: [
                {
                  item_id: eventCurrentProductID,
                  item_name: eventCurrentProductTitle,
                  item_variant_id: eventProductCurrentVariantID,
                  item_price: eventProductPrice
                }
              ]
            }
          });
        }
      }
      //END 2.EVENT - Add Events GA GTM [select_cta] : if user select or hit the CTA button

      updateCloseTextPosition();
      const sellingPlanInput = document.querySelector('#is-subscription-only');
      const sellingPlanName = sellingPlanInput?.getAttribute('data-selling-plan-name').toLocaleLowerCase();
      const targetSubscriptionFrequency = document.querySelectorAll('#drawer-next-order-shipment .drawer-content');
      targetSubscriptionFrequency.forEach(el => {
          el.innerHTML = el.innerHTML.replace('[frequency]', sellingPlanName);
      });
      /** On Subscription product change and get thr one time and subscription value
      * 1. Change the modal product quantity to 1 if user change the product type
      */
      handleModalContent();
    });

    // #5. One-Time & Subscription product bind with the upcoming shipment
    document.getElementById('add-to-next-shipment').addEventListener('click', function(e) {
      const nextShipmentConfirmButton = e.currentTarget;
      let oneTimeInput = document.querySelector('input[aria-label="One-time purchase"]');
      let CurrentProductID = document.querySelector('#pdp-content .product-form [name="product-main-id"]').value;
      let CurrentProductTitle = document.querySelector('#pdp-content .product-form [name="product-title"]').value;
      let productCurrentVariantID = document.querySelector('#pdp-content .product-form [name="items[0]id"]').value;
      let productNextShipmentDate = nextSubscriptionDetails.next_charge_scheduled_at;
      let productNextShipmentAddress = nextSubscriptionDetails.address_id;
      // let chargeIntervalFrequency = nextSubscriptionDetails.charge_interval_frequency;
      // let orderIntervalFrequency= nextSubscriptionDetails.order_interval_frequency;

      // get Interval Frequency In Days
      const hiddenInput = document.getElementById('is-subscription-only');
      let intervalFrequencyInDays = '';
      if(hiddenInput){
        const rowIntervalFrequencyInDays = hiddenInput.dataset.orderIntervalFrequency;
        // Remove "-day" and keep only number
        intervalFrequencyInDays = rowIntervalFrequencyInDays.replace('-day', '');
      }

      try {
        if (nextShipmentConfirmButton) {
          // disable button
          nextShipmentConfirmButton.disabled = true;
          nextShipmentConfirmButton.querySelector('.confirm').style.display = 'none';
          nextShipmentConfirmButton.querySelector('.added').style.display = 'none';
          // show loader
          nextShipmentConfirmButton.querySelector('.loading-overlay').classList.remove('hidden');
        }
      } catch (error) {
        console.error("not click:", error);
      }
      // const subscriptionInputPDP = document.querySelector('.selected-selling-plan-id');
      const qtyProductValue = document.querySelector('drawer-next-shipment .footer input.quantity__input').value;

      const subscriptionInputEl = document.querySelector('#is-subscription-only');
      if (subscriptionInputEl && subscriptionInputEl.value) {
        recharge.subscription.createSubscription(session, {
          address_id: productNextShipmentAddress,
          charge_interval_frequency: intervalFrequencyInDays,
          next_charge_scheduled_at: productNextShipmentDate,
          order_interval_frequency: intervalFrequencyInDays,
          order_interval_unit: 'day',
          quantity: qtyProductValue,
          external_variant_id: {
            ecommerce: productCurrentVariantID,
          },
          external_product_id: {
            ecommerce: CurrentProductID,
          },
        })
        .then(subscriptionProduct => {
          handleNextShipmentActions(nextShipmentConfirmButton, 'success');
          //START 3.EVENT - Add Events GA GTM [order_ship_with_next_order] : if product added with subscription [Subscription product]
          if(hasActiveSubscriptionCount){
            let eventCurrentProductID = document.querySelector('#pdp-content .product-form [name="product-main-id"]').value;
            let eventCurrentProductTitle = document.querySelector('#pdp-content .product-form [name="product-title"]').value;
            let eventProductCurrentVariantID = document.querySelector('#pdp-content .product-form [name="items[0]id"]').value;
            let eventProductPrice = document.querySelector('.price .price-item').innerHTML;
            let buttonParent = document.getElementById('next-order-shipment-box-button');
            let buttonID = buttonParent.querySelectorAll('[id]');
            let spans = buttonParent.querySelectorAll('span');
            let ctaID = '';
            let buttonText = '';
            // button ID
            buttonID.forEach(el => {
              ctaID = el.id
            });
            // button text through spans
            spans.forEach(el => {
              const style = window.getComputedStyle(el);
              if (style.display === 'block') {
                buttonText = el.textContent.trim();
              }
            });
            console.log("hasActiveSubscriptionCount if true then", hasActiveSubscriptionCount);
            if (window.Shopify?.analytics) {
              window.Shopify.analytics.publish('order_ship_with_next_order', {
                user_properties: {
                  subscriber: 'true'
                },
                cta_id: ctaID,
                cta_name: buttonText,
                cta_slot: "product_details_page",
                address_id: nextSubscriptionDetails.address_id,
                subscription_id: nextSubscriptionDetails.id,
                charge_id: subscriptionProduct.customer_id,
                ecommerce: {
                  currency: nextSubscriptionDetails.presentment_currency,
                  value: subscriptionProduct.price,
                  items: [
                    {
                      item_id: eventCurrentProductID,
                      item_name: eventCurrentProductTitle,
                      item_variant_id: eventProductCurrentVariantID,
                      item_price: eventProductPrice,
                      is_subscription: true,
                      recurrence_unit: subscriptionProduct.order_interval_unit,
                      recurrence_count: subscriptionProduct.order_interval_frequency,
                      next_charge_datetime: subscriptionProduct.next_charge_scheduled_at,
                      next_charge_timestamp: 'false'
                    }
                  ]
                }
              });
            }
          }
          //END 3.EVENT - Add Events GA GTM [order_ship_with_next_order] : if product added with subscription [Subscription product]
        })
        .catch(error => {
          handleNextShipmentActions(nextShipmentConfirmButton);
          //START 4.EVENT - Add Events GA GTM [Error order_ship_with_next_error]
          if(hasActiveSubscriptionCount){
            console.log("hasActiveSubscriptionCount if true then", hasActiveSubscriptionCount);
            if (window.Shopify?.analytics) {
              window.Shopify.analytics.publish('order_ship_with_next_error');
            }
          }
          //END 4.EVENT - Add Events GA GTM [Error order_ship_with_next_error]
        });
      } else if (oneTimeInput && oneTimeInput.checked) {

          let originalVariantId;
          // get product form
          const productForm = document.querySelector(".product-block__buy_buttons product-form");
          const formData = new FormData(productForm.querySelector('form'));
          const form = productForm.querySelector('form');
          const disabledInputs = form.querySelectorAll(':disabled');
          disabledInputs.forEach(input => input.disabled = false);

          let prdId;
          let varId;
          for (let [key, value] of formData.entries()) {
            if (key === 'product-one-time-id') {
              prdId = value
            } else if (key === 'items[0]id') {
              varId = value;
            }
          }

          disabledInputs.forEach(input => input.disabled = true);

          const sellingPlanPicker = productForm.sellingPlanPicker;
          let sectionId = document.querySelector('.product-main selling-plan-picker').getAttribute('data-section-id');
          let otVariantFound = false;

          if (sellingPlanPicker && sellingPlanPicker.elements.oneTimeRadio && sellingPlanPicker.elements.oneTimeRadio.checked) {
            const oneTimeProductJson = JSON.parse(document.querySelector('[data-one-time-product-json]').textContent);
            const nonABTestingCompatibleVariantSwitcher = document.querySelector(`variant-radios[data-section="${sectionId}"]`) || document.querySelector(`variant-selects[data-section="${sectionId}"]`);
            const abTestingCompatibleSectionID = `${sectionId}-${CurrentProductID}`;
            const abTestingCompatibleVariantSwitcher = document.querySelector(`variant-radios[data-section="${abTestingCompatibleSectionID}"]`) || document.querySelector(`variant-selects[data-section="${abTestingCompatibleSectionID}"]`);

            let variantSwitcher;
            if (abTestingCompatibleVariantSwitcher) {
              variantSwitcher = abTestingCompatibleVariantSwitcher
            } else {
              variantSwitcher = nonABTestingCompatibleVariantSwitcher
            }

            const oneTimeProductSameVariant = oneTimeProductJson.find(variant =>
              variant.title === variantSwitcher.currentVariant.title
            );
            if (oneTimeProductSameVariant) {
              otVariantFound = true;
              originalVariantId = productForm.querySelector('form').querySelector('[name="items[0]id"]').value;
              productForm.querySelector('form').querySelector('[name="items[0]id"]').value = oneTimeProductSameVariant.id;
              varId = oneTimeProductSameVariant.id.toString();
              CurrentProductTitle = oneTimeProductSameVariant.name;
            } else {
              console.error("Variant not found!");
              handleNextShipmentActions(nextShipmentConfirmButton);
              //START 4.EVENT - Add Events GA GTM [Error order_ship_with_next_error]
              if(hasActiveSubscriptionCount){
                console.log("hasActiveSubscriptionCount if true then", hasActiveSubscriptionCount);
              }
              if (window.Shopify?.analytics) {
                window.Shopify.analytics.publish('order_ship_with_next_error');
              }
              //END 4.EVENT - Add Events GA GTM [Error order_ship_with_next_error]
            }
          }
          if (otVariantFound) {
            recharge.onetime.createOnetime(session, {
              address_id: productNextShipmentAddress,
              next_charge_scheduled_at: productNextShipmentDate,
              quantity: qtyProductValue,
              external_variant_id: {
                ecommerce:  varId,
              },
              external_product_id: {
                ecommerce: prdId,
              },
              product_title: CurrentProductTitle,
            })
            .then(onetime => {
              handleNextShipmentActions(nextShipmentConfirmButton, 'success');

              //START 3.EVENT - Add Events GA GTM [order_ship_with_next_order] : if product added with subscription [Subscription product]
              let eventCurrentProductID = document.querySelector('#pdp-content .product-form [name="product-main-id"]').value;
              let eventCurrentProductTitle = document.querySelector('#pdp-content .product-form [name="product-title"]').value;
              let eventProductCurrentVariantID = document.querySelector('#pdp-content .product-form [name="items[0]id"]').value;
              let eventProductPrice = document.querySelector('.price .price-item').innerHTML;
              let buttonParent = document.getElementById('next-order-shipment-box-button');
              let buttonID = buttonParent.querySelectorAll('[id]');
              let spans = buttonParent.querySelectorAll('span');
              let ctaID = '';
              let buttonText = '';
              // button ID
              buttonID.forEach(el => {
                ctaID = el.id
              });
              // button text through spans
              spans.forEach(el => {
                const style = window.getComputedStyle(el);
                if (style.display === 'block') {
                  buttonText = el.textContent.trim();
                }
              });

              if(hasActiveSubscriptionCount){
                console.log("hasActiveSubscriptionCount if true then", hasActiveSubscriptionCount);
                if (window.Shopify?.analytics) {
                  window.Shopify.analytics.publish('order_ship_with_next_order', {
                    user_properties: {
                      subscriber: 'true'
                    },
                    cta_id: ctaID,
                    cta_name: buttonText,
                    cta_slot: "product_details_page",
                    address_id: onetime.address_id,
                    subscription_id: onetime.id,
                    charge_id: onetime.customer_id,
                    ecommerce: {
                      currency: nextSubscriptionDetails.presentment_currency,
                      value: onetime.price,
                      items: [
                        {
                          item_id: eventCurrentProductID,
                          item_name: eventCurrentProductTitle,
                          item_variant_id: eventProductCurrentVariantID,
                          item_price: eventProductPrice,
                          is_subscription: 'false',
                          recurrence_unit: 'false',
                          recurrence_count: 'false',
                          next_charge_datetime: 'false',
                          next_charge_timestamp: 'false'
                        }
                      ]
                    }
                  });
                }
              }
              //END 3.EVENT - Add Events GA GTM [order_ship_with_next_order] : if product added with subscription [Subscription product]
            })
            .catch(error => {
              console.error("Error occurred :", error);
              handleNextShipmentActions(nextShipmentConfirmButton);
              if(hasActiveSubscriptionCount){
                console.log("hasActiveSubscriptionCount if true then", hasActiveSubscriptionCount);
              }
              //START 4.EVENT - Add Events GA GTM [order_ship_with_next_error]
              if (window.Shopify?.analytics) {
                window.Shopify.analytics.publish('order_ship_with_next_error');
              }
              //END 4.EVENT - Add Events GA GTM [order_ship_with_next_error]
            });
          }
        } else {
          recharge.onetime.createOnetime(session, {
            address_id: productNextShipmentAddress,
            next_charge_scheduled_at: productNextShipmentDate,
            quantity: qtyProductValue,
            external_variant_id: {
              ecommerce: productCurrentVariantID,
            },
            external_product_id: {
              ecommerce: CurrentProductID,
            },
            product_title: CurrentProductTitle,
          })
          .then(onetime => {
            handleNextShipmentActions(nextShipmentConfirmButton, 'success');
            //START 3.EVENT - Add Events GA GTM [order_ship_with_next_order] : if product added with subscription [Subscription product]
            let eventCurrentProductID = document.querySelector('#pdp-content .product-form [name="product-main-id"]').value;
            let eventCurrentProductTitle = document.querySelector('#pdp-content .product-form [name="product-title"]').value;
            let eventProductCurrentVariantID = document.querySelector('#pdp-content .product-form [name="items[0]id"]').value;
            let eventProductPrice = document.querySelector('.price .price-item').innerHTML;
            let buttonParent = document.getElementById('next-order-shipment-box-button');
            let buttonID = buttonParent.querySelectorAll('[id]');
            let spans = buttonParent.querySelectorAll('span');
            let ctaID = '';
            let buttonText = '';
            // button ID
            buttonID.forEach(el => {
              ctaID = el.id
            });
            // button text through spans
            spans.forEach(el => {
              const style = window.getComputedStyle(el);
              if (style.display === 'block') {
                buttonText = el.textContent.trim();
              }
            });
            if(hasActiveSubscriptionCount){
              console.log("hasActiveSubscriptionCount if true then", hasActiveSubscriptionCount);
              if (window.Shopify?.analytics) {
                window.Shopify.analytics.publish('order_ship_with_next_order', {
                  user_properties: {
                    subscriber: 'true'
                  },
                  cta_id: ctaID,
                  cta_name: buttonText,
                  cta_slot: "product_details_page",
                  address_id: onetime.address_id,
                  subscription_id: onetime.id,
                  charge_id: onetime.customer_id,
                  ecommerce: {
                    currency: nextSubscriptionDetails.presentment_currency,
                    value: onetime.price,
                    items: [
                      {
                        item_id: eventCurrentProductID,
                        item_name: eventCurrentProductTitle,
                        item_variant_id: eventProductCurrentVariantID,
                        item_price: eventProductPrice,
                        is_subscription: 'false',
                        recurrence_unit: 'false',
                        recurrence_count: 'false',
                        next_charge_datetime: 'false',
                        next_charge_timestamp: 'false'
                      }
                    ]
                  }
                });
              }
            }
            //END 3.EVENT - Add Events GA GTM [order_ship_with_next_order] : if product added with subscription [Subscription product]
          })
          .catch(error => {
            console.error("Error occurred :", error);
            handleNextShipmentActions(nextShipmentConfirmButton);
            //START 4.EVENT - Add Events GA GTM [order_ship_with_next_error]
            if (window.Shopify?.analytics) {
              window.Shopify.analytics.publish('order_ship_with_next_error');
            }
            //END 4.EVENT - Add Events GA GTM [order_ship_with_next_error]
          });
        }
    });
  }).catch(err => {
      // Console error if issue occure in the fetching
      console.error('Error fetching customer:', err);
  });
});

document.addEventListener('click', function(event) {
  // Check if the clicked element or matches the close button
  if (event.target.closest('.pop-up-message-ship-with-next-order .close-box')) {
    const popup = document.querySelector('.pop-up-message-ship-with-next-order');
    if (popup) {
      popup.style.display = 'none';
    }
  }
});

function updateCloseTextPosition() {
  const drawer = document.querySelector('#drawer-next-order-shipment .drawer-panel');
  const closeText = document.querySelector('#drawer-next-order-shipment .close-text');

  if (!drawer || !closeText) return;

  const actualHeight = drawer.clientHeight; // current drawer height
  const gap = 43; // gap in px

  closeText.style.bottom = `${actualHeight + gap}px`;
}
// modal and button functionalities on success
function triggerMessageModal(msgModal) {
  if (msgModal) {
    setTimeout(()=>{
      msgModal.style.display = "flex";
      // Hide after 5 seconds
      setTimeout(() => {
        msgModal.style.display = "none";
      }, 5500);
    },1400)
  }
}
// handle the modal success and error trigger
function handleNextShipmentActions(nextShipmentConfirmButton, action) {
  // cart drawer selector
  const drawer = document.getElementById('drawer-next-order-shipment');

  // hide "confirm" text on button
  nextShipmentConfirmButton.querySelector('.confirm').style.display = 'none';

  // hide loader
  if (action === 'success') {
    document.querySelector('#add-to-next-shipment .loading-overlay')?.classList.add('hidden');
  }

  // show "Added" text on button for success only
  if (action === 'success') {
    nextShipmentConfirmButton.querySelector('.added').style.display = 'block';
  }

  // close drawer and make button ready for next click
  if (drawer) {
    const closeBtn = drawer.querySelector('[data-close]');
    setTimeout(() => {
      if (closeBtn) closeBtn.click();
      nextShipmentConfirmButton.disabled = false;
      nextShipmentConfirmButton.querySelector('.confirm').style.display = 'block';
      nextShipmentConfirmButton.querySelector('.added').style.display = 'none';

      // enable button
      nextShipmentConfirmButton.disabled = false;

      // hide loader for error condition
      if (action !== 'success') {
        document.querySelector('#add-to-next-shipment .loading-overlay')?.classList.add('hidden');
      }
    }, 1200);
  }

  // choose success / error message modal
  let msgModal;
  if (action === 'success') {
    msgModal = document.querySelector('.ship-with-next-order-success-message');
  } else {
    msgModal = document.querySelector('.ship-with-next-order-error-message');
  }

  // trigger msg modal
  triggerMessageModal(msgModal);
}

// Modal content on subscription product to handle for show and hide message accordingly
function handleModalContent () {
  const radios = document.querySelectorAll('.radio-card__details input[type="radio"]');
  const quantityInput = document.querySelector('drawer-next-shipment .footer input.quantity__input');
  const subscriptionMessage = document.querySelector('.subsProduct-details .subscription-message-details');
  const oneTimeMessage = document.querySelector('.subsProduct-details .one-time-message-details');
  const shipWithNexOrderButtonToggle = document.getElementById("next-order-shipment-button");
  const shipWithNexOrderButtonSubscription = document.querySelector("#next-order-shipment-button .subscription-text");
  const shipWithNexOrderButtonOnetime = document.querySelector("#next-order-shipment-button .onetime-text");
  const isSubscriptionOnly = document.getElementById("is-subscription-only");

  // helper function to update messages
  function updateMessages(radio) {
    if (!radio) return;

    // reset quantity
    if (quantityInput) quantityInput.value = 1;

    // hide both
    if (subscriptionMessage) subscriptionMessage.style.display = 'none';
    if (oneTimeMessage) oneTimeMessage.style.display = 'none';
    if (shipWithNexOrderButtonSubscription) shipWithNexOrderButtonSubscription.style.display = 'none';
    if (shipWithNexOrderButtonOnetime) shipWithNexOrderButtonOnetime.style.display = 'none';

    // check aria-label
    if (radio.getAttribute("aria-label") === "Subscription purchase") {
      if (subscriptionMessage) subscriptionMessage.style.display = 'block';
      if (shipWithNexOrderButtonToggle) {
        shipWithNexOrderButtonSubscription.style.display = 'block';
      }
    } else if (radio.getAttribute("aria-label") === "One-time purchase") {
      if (oneTimeMessage) oneTimeMessage.style.display = 'block';
      if (shipWithNexOrderButtonToggle) {
        shipWithNexOrderButtonOnetime.style.display = 'block';
      }
    } else {
      if (subscriptionMessage) subscriptionMessage.style.display = 'block';
      if (shipWithNexOrderButtonToggle) {
        shipWithNexOrderButtonSubscription.style.display = 'block';
      }
    }
  }

  // attach event
  radios.forEach(radio => {
    radio.addEventListener('change', () => updateMessages(radio));
  });
  // run on load (for the initially selected radio)
  const checkedRadio = document.querySelector('.radio-card__details input[type="radio"]:checked');
  if (checkedRadio) {
    updateMessages(checkedRadio);
  } else if (isSubscriptionOnly) {
    //runs if #is-subscription-only exists
    if (shipWithNexOrderButtonSubscription) {
    updateMessages(shipWithNexOrderButtonSubscription);
      shipWithNexOrderButtonSubscription.style.display = 'block';
    }
  } else {
    if (subscriptionMessage) subscriptionMessage.style.display = 'block';
    if (shipWithNexOrderButtonToggle) {
      shipWithNexOrderButtonOnetime.style.display = 'block';
    }
  }
}

// Run on window load
window.addEventListener('load', () => {
  updateCloseTextPosition();
  handleModalContent();
});

// Run on window resize
window.addEventListener('resize', updateCloseTextPosition);
